<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- บริษัท -->
              <v-select
                v-model="Company"
                :items="CompanyItem"
                dense
                outlined
                clearable
                clear-icon="mdi-close-circle"
                @change="getDataBranch(Company)"
                hide-details
                label="บริษัท"
                class="ma-2"
              ></v-select>
              <!-- สาขา -->
              <v-select
                v-model="Branch"
                :items="BranchItem"
                @change="getDataDepartment(Branch)"
                dense
                outlined
                clearable
                clear-icon="mdi-close-circle"
                hide-details
                label="สาขา"
                class="ma-2"
              ></v-select>
              <!-- แผนก -->
              <v-select
                v-model="Department"
                :items="DepartmentItem"
                @change="departmentCheckSearch(Department)"
                dense
                outlined
                hide-details
                clearable
                clear-icon="mdi-close-circle"
                label="แผนก"
                class="ma-2"
              ></v-select>

              <v-col cols="4">
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="endDate"
                prepend-icon="mdi-calendar"
                label="วันที่ลาออก"
                readonly
                outlined
                dense
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              locale="th-th"
              v-model="endDate"
              @input="menu2 = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
              <v-icon color="#871B12" size="30" @click="getData()"
                >mdi-calendar-search</v-icon
              >
              <v-icon color="#871B12" size="30" @click="clear()"
                >mdi-refresh</v-icon
              >
            </v-sheet>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-btn color="yellow-light" @click="exportData()">
              <v-icon left>mdi-download</v-icon>
              Export Data
            </v-btn>
          </v-col>

          <v-dialog
            v-model="dialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
          >
            <v-card>
              <v-toolbar dark color="primary">
                <v-btn icon dark @click=";(dialog = false), getData()">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>รายละเอียด</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>

              <v-col cols="12">
              <v-row>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="6">
                      <v-sheet tile height="54" class="d-flex">
                        <v-select
                          v-model="month"
                          :items="monthNameTH"
                          dense
                          outlined
                          hide-details
                          label="เดือน"
                          class="ma-2"
                        ></v-select>
                        <v-select
                          v-model="year"
                          :items="yearsNumber"
                          dense
                          outlined
                          hide-details
                          label="ปี"
                          class="ma-2"
                        ></v-select>
                        <v-icon
                          color="#262A34"
                          size="50"
                          @click="getSearch()"
                          >mdi-card-search</v-icon
                        >
                      </v-sheet>
                    </v-col>
                  </v-row>
                  <v-btn
                  color="blue-grey"
                  class="ma-2 white--text"
                  @click="exportByEmp()"
                >
                  Export Data
                  <v-icon right dark> mdi-download </v-icon>
                </v-btn>
                  <v-card>
                    <v-row>
                      <v-col cols="3">
                        <v-card elevation="12" height="1350px" >
                          <center>
                            <v-toolbar color="#B61C1C" dark>
                              <v-toolbar-title> <v-icon color="whire">mdi-account-circle</v-icon> ข้อมูล</v-toolbar-title>
                            </v-toolbar>
                    <br />
                          </center>
                          <v-col>
                            <v-list-item-avatar>
                      <v-img :src="dataByEmp.empImageUrl"></v-img>
                    </v-list-item-avatar>
                            <v-card-text
                              ><v-icon color="#871B12"
                                >mdi-account-circle</v-icon
                              ><strong>รหัสพนักงาน: </strong
                              >{{ empCode }}
                            </v-card-text>
                            <v-card-text
                              ><v-icon color="#871B12"
                                >mdi-account-circle</v-icon
                              ><strong>ชื่อ นามสกุล: </strong
                              >{{ empFull_NameTH }}
                            </v-card-text>
                            <v-card-text>
                              <v-icon color="#871B12">mdi-briefcase</v-icon>
                              <strong>หน่วยงาน: </strong
                              >{{ masDepartmentName }}
                            </v-card-text>
                            <v-card-text>
                              <v-icon color="#871B12"
                                >mdi-map-marker-radius</v-icon
                              >
                              <strong>สาขา : </strong
                              >{{ masBranchName }}
                            </v-card-text>
                          </v-col>
                        </v-card>
                      </v-col>
                      <v-col cols="5">
                        <v-card elevation="12">
                          <v-simple-table fixed-header height="1350px">
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th
                                    class="text-center white--text"
                                    style="background-color: #262A34"
                                  >
                                    วัน/เดือน/ปี
                                  </th>
                                  <th
                                class="text-center"
                                style="background-color: #1b437c"
                              >
                                รหัสกะ
                              </th>
                                  <th
                                    class="text-center white--text"
                                    style="background-color: #262A34"
                                  >
                                    เวลาเข้างาน
                                  </th>
                                  <th
                                    class="text-center white--text"
                                    style="background-color: #262A34"
                                  >
                                    เวลาเลิกงาน
                                  </th>
                                  <th
                                    class="text-center white--text"
                                    style="background-color: #262A34"
                                  >
                                    เวลาสาย
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(items1, index1) in dataByEmp"
                                  :key="index1"
                                >
                                  <td class="text-center">
                                    {{ items1.shiftDay }}/{{
                                      items1.shiftMonth
                                    }}/{{ items1.shiftYear }}
                                  </td>
                                  <td class="text-center">
                                    <v-chip
                                      label
                                      class="ma-2"
                                      color="#001EFF"
                                      text-color="white"
                                    >
                                      {{ items1.shiftCode }}
                                    </v-chip>
                                  </td>
                                  <td class="text-center">
                                    <v-chip
                                      class="ma-2"
                                      :color="items1.colorin"
                                      text-color="white"
                                      label
                                    >
                                      {{ items1.checkInStartStamp }}
                                    </v-chip>
                                  </td>
                                  <td class="text-center">
                                    <v-chip
                                      class="ma-2"
                                      :color="items1.colorout"
                                      v-if="items1.checkInEndStamp"
                                      text-color="white"
                                      label
                                    >
                                      {{ items1.checkInEndStamp }}
                                    </v-chip>
                                  </td>
                                  <td class="text-center">
                                    <v-chip
                                      class="ma-2"
                                      text-color="white"
                                      label
                                      color="red"
                                      v-if="
                                        items1.lateTime !== '00:00' &&
                                          items1.lateTime
                                      "
                                    >
                                      {{ items1.lateTime }}
                                    </v-chip>
                                    <v-chip
                                      class="ma-2"
                                      text-color="white"
                                      label
                                      color="green"
                                      v-if="items1.lateTime === '00:00'"
                                    >
                                      {{ items1.lateTime }}
                                    </v-chip>
                                    <v-chip
                                      class="ma-2"
                                      text-color="white"
                                      label
                                      v-if="!items1.lateTime"
                                    >
                                      ไม่พบข้อมูล
                                    </v-chip>
                                  </td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </v-card>
                      </v-col>
                      <v-col cols="4">
                        <v-card elevation="12">
                          <v-simple-table fixed-header height="1350px">
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th
                                    class="text-center white--text"
                                    style="background-color: #262A34"
                                  >
                                    วัน/เดือน/ปี
                                  </th>
                                  <th
                                    class="text-center white--text"
                                    style="background-color: #262A34"
                                  >
                                    เวลา
                                  </th>
                                  <th
                                    class="text-center white--text"
                                    style="background-color: #262A34"
                                  >
                                    สี
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(items2, index) in dataByEmp"
                                  :key="index"
                                >
                                  <td class="text-center">
                                    {{ items2.shiftDay }}/{{
                                      items2.shiftMonth
                                    }}/{{ items2.shiftYear }}
                                  </td>
                                  <td v-if="items2.time_as" class="text-center">
                                    {{ items2.time_as }}
                                  </td>
                                  <td v-if="!items2.time_as" class="text-center">
                                    <v-chip class="ma-2" label>
                                      ไม่พบข้อมูล
                                    </v-chip>
                                  </td>
                                  <td class="text-center">
                                    <v-chip
                                      v-if="items2.color === 'สีเขียว'"
                                      class="ma-2"
                                      color="green"
                                      text-color="white"
                                      label
                                    >
                                      {{ items2.color }}
                                    </v-chip>
                                    <v-chip
                                      v-if="items2.color === 'สีเหลือง'"
                                      class="ma-2"
                                      color="yellow"
                                      text-color="black"
                                      label
                                    >
                                      {{ items2.color }}
                                    </v-chip>
                                    <v-chip
                                      v-if="items2.color === 'สีส้ม'"
                                      class="ma-2"
                                      color="orange"
                                      text-color="black"
                                      label
                                    >
                                      {{ items2.color }}
                                    </v-chip>
                                    <v-chip
                                      v-if="items2.color === 'สีแดง'"
                                      class="ma-2"
                                      color="red"
                                      text-color="black"
                                      label
                                    >
                                      {{ items2.color }}
                                    </v-chip>
                                    <v-chip
                                      class="ma-2"
                                      v-if="!items2.color"
                                      label
                                    >
                                      ไม่พบข้อมูล
                                    </v-chip>
                                  </td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </v-card>
                      </v-col>
                    <v-divider class="mx-4"></v-divider>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>

                <v-row>
                  <!-- ประวัติยกเลิก -->
                  <v-col cols="12">
                    <v-alert dense type="success" icon="mdi-account-check">
                      รายการ <strong>ขอสลับกะ</strong>
                    </v-alert>
                    <v-card elevation="7" v-if="dataReady">
                      <v-card-title>
                        <v-text-field
                          v-model="searchAll"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                        ></v-text-field>
                      </v-card-title>
                      <v-card-text>
                        <v-data-table
                          :headers="columnsShift"
                          :items="dataItemShift"
                          :search="searchAll"
                          :items-per-page="10"
                        >
                          <template
                            v-slot:[`item.shiftTransferFriendAppoveStatus`]="{
                              item
                            }"
                          >
                            <v-chip
                              class="ma-2"
                              color="secondary"
                              text-color="white"
                              v-if="
                                item.shiftTransferFriendAppoveStatus ===
                                  'waiting'
                              "
                            >
                              <v-icon left> mdi-account-clock </v-icon>
                              รอยืนยัน
                            </v-chip>
                            <v-chip
                              class="ma-2"
                              color="red"
                              text-color="white"
                              v-if="
                                item.shiftTransferFriendAppoveStatus ===
                                  'cancel'
                              "
                            >
                              <v-icon left> mdi-account-remove </v-icon>
                              ยกเลิก
                            </v-chip>
                            <v-chip
                              class="ma-2"
                              color="green"
                              text-color="white"
                              v-if="
                                item.shiftTransferFriendAppoveStatus ===
                                  'approve'
                              "
                            >
                              <v-icon> mdi-account-check-outline </v-icon>
                              ยืนยัน
                            </v-chip>
                          </template>
                          <template
                            v-slot:[`item.shiftTransferAppoveStatus`]="{ item }"
                          >
                            <v-chip
                              class="ma-2"
                              color="secondary"
                              text-color="white"
                              v-if="
                                item.shiftTransferAppoveStatus === 'waiting' &&
                                  item.shiftTransferFriendAppoveStatus !==
                                    'cancel'
                              "
                            >
                              <v-icon left> mdi-account-clock </v-icon>
                              รอดำเนินการ
                            </v-chip>
                            <v-chip
                              class="ma-2"
                              color="success"
                              v-if="
                                item.shiftTransferAppoveStatus === 'approve'
                              "
                            >
                              <v-icon> mdi-account-check-outline </v-icon>
                              อนุมัติ
                            </v-chip>
                            <v-chip
                              class="ma-2"
                              color="red"
                              text-color="white"
                              v-if="
                                item.shiftTransferAppoveStatus === 'unapprove'
                              "
                            >
                              <v-icon left> mdi-account-remove </v-icon>
                              ไม่อนุมัติ
                            </v-chip>
                          </template>
                          <template
                            v-slot:[`item.action_approve_friend`]="{ item }"
                          >
                            <v-btn
                              color="info"
                              @click=";(employeeInfo = []), getInfoDetail(item)"
                            >
                              ตรวจสอบ
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                    <div v-if="!dataReady" class="text-center">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </div>
                  </v-col>
                  <!-- end data table -->
                  <v-col cols="12">
                    <v-alert dense type="info" icon="mdi-account-switch">
                      รายการ <strong>ขอลา</strong>
                    </v-alert>
                    <v-card elevation="7" v-if="dataReady">
                      <v-card-title>
                        <v-text-field
                          v-model="searchAll1"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                        ></v-text-field>
                      </v-card-title>
                      <v-card-text>
                        <v-data-table
                          :headers="columnsItem"
                          :items="dataItemLeave"
                          :search="searchAll1"
                          :items-per-page="10"
                        >
                          <template v-slot:[`item.leaveEmergency`]="{ item }">
                            <v-btn
                              color="warning"
                              fab
                              small
                              dark
                              v-if="item.leaveEmergency"
                            >
                              <v-icon>mdi-alert</v-icon>
                            </v-btn>
                          </template>
                          <template v-slot:[`item.action`]="{ item }">
                            <v-btn
                              color="info"
                              @click="getDataById(item), (dialog = true)"
                            >
                              ตรวจสอบ
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                    <div v-if="!dataReady" class="text-center">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-card>
          </v-dialog>

          <!-- data table -->
          <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll2"
                  :items-per-page="10"
                >
                  <template v-slot:[`item.action`]="{ item }">
                    <v-btn
                      color="#1A237E"
                      dark
                      fab
                      small
                      @click.stop=";(dialog = true),
                        getDataInformation(item),
                          getByEmp(item)
                      "
                    >
                      <v-icon dark> mdi-map-marker </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import titleNameTH from '../../../assets/master/titleName/titleNameTH.json'
import monthNameTH from '../../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../../assets/master/Date/yearsNumber.json'

import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile,
    moment
  },
  created () {
    setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      e1: 1,
      PK: '',
      path: '/employee_resign/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'ข้อมูลพนักงานลาออก',
          disabled: true,
          href: '/HRM/Employee/EmployeeResign'
        }
      ],
      // End Menu Config
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      // date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      // dateFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      // menu1: false,
      // menu: false,
      menu2: false,
      // menu3: false,
      // menu4: false,
      code: 'EMP', // Generate Code
      // Dialog ADD IMPORT
      dialogAdd: false,
      dialogImport: false,
      panel1: '',
      session: this.$session.getAll(),
      searchAll: '',
      searchAll1: '',
      searchAll2: '',
      // Search Advanced
      search: {
        empCode: '',
        empFull_NameTH: '',
        create_date_start: '',
        create_date_end: '',
        last_date_start: '',
        last_date_end: ''
      },

      // form Info //
      formAdd: {
        empCode: '',
        empId: '',
        empTitle_NameTH: '',
        empFirst_NameTH: '',
        empLast_NameTH: ''
      },
      empFull_NameTH: '',
      masDepartmentName: '',
      masBranchName: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 50) || 'Name must be less than 50 characters'
      ],
      // Data Table Config
      columns: [
        { text: 'รหัสพนักงาน', value: 'empCode', align: 'center' },
        { text: 'ชื่อ-นามสกุล', value: 'empFull_NameTH' },
        { text: 'ประเภทพนักงาน', value: 'positionTypeName' },
        { text: 'ตำแหน่ง', value: 'positionName' },
        { text: 'แผนก', value: 'masDepartmentName' },
        { text: 'สาขา', value: 'masBranchName' },
        // { text: 'บริษัท', value: 'masCompanyName' },
        { text: 'วันเข้าทำงาน', value: 'startDate' },
        { text: 'วันที่ลาออก', value: 'endDate' },
        { text: 'อายุงาน', value: 'workDate' },
        // { text: 'วันที่อัพเดท', value: 'LAST_DATE' },
        { text: 'Action', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],
      dataInfoItem: [],
      // End Data Table Config

      // Config Import
      // columnsImport: [
      //   { text: 'empId', value: 'empId' },
      //   { text: 'empCode', value: 'empCode' },
      //   { text: 'positionCode', value: 'positionCode' },
      //   { text: 'empTitle_NameTH', value: 'empTitle_NameTH' },
      //   { text: 'empFirst_NameTH', value: 'empFirst_NameTH' },
      //   { text: 'empLast_NameTH', value: 'empLast_NameTH' },
      //   { text: 'empTitle_NameEN', value: 'empTitle_NameEN' },
      //   { text: 'empFirst_NameEN', value: 'empFirst_NameEN' },
      //   { text: 'empLast_NameEN', value: 'empLast_NameEN' },
      //   { text: 'empNickname', value: 'empNickname' },
      //   { text: 'empBirthday', value: 'empBirthday' },
      //   { text: 'empGender', value: 'empGender' },
      //   { text: 'empIDCard', value: 'empIDCard' },
      //   { text: 'empEmail', value: 'empEmail' },
      //   { text: 'empTel', value: 'empTel' },
      //   { text: 'empEmergencyCall', value: 'empEmergencyCall' },
      //   { text: 'empFacebook', value: 'empFacebook' },
      //   { text: 'empLineID', value: 'empLineID' },
      //   { text: 'empDriverLicense', value: 'empDriverLicense' },
      //   { text: 'empDriverLicenseType', value: 'empDriverLicenseType' }
      // ],
      // dataItemImportChecKHide: true,
      // dataItemImport: [],
      columnsShift: [
        { text: 'ประเภท', value: 'shiftTransferType' },
        { text: 'พนักงาน', value: 'empFull_NameTH' },
        { text: 'กะปัจุบัน', value: 'shiftTransferOldShiftCodeName' },
        { text: 'เพื่อน', value: 'empFull_NameTH_Friend' },
        { text: 'กะที่สลับ', value: 'shiftTransferNewShiftCodeName' },
        { text: 'หมายเหตุ', value: 'shiftTransferRemark' },
        { text: 'เพื่อนอนุมัติ', value: 'shiftTransferFriendAppoveStatus' },
        { text: 'หัวหน้าอนุมัติ', value: 'shiftTransferAppoveStatus' },
        { text: 'ทำรายการล่าสุด', value: 'lastUser' }
        // {
        //   text: 'ตรวจสอบ',
        //   value: 'action_approve_friend',
        //   sortable: false,
        //   align: 'center'
        // }
      ],
      columnsItem: [
        { text: 'รหัสพนักงาน', value: 'empCode' },
        { text: 'พนักงาน', value: 'empFull_NameTH' },
        { text: 'ประเภท', value: 'quotaLeaveName' },
        { text: 'ตั้งแต่', value: 'leaveStartDate' },
        { text: 'ถึง', value: 'leaveEndDate' },
        { text: 'จำนวน', value: 'leaveSummaryDay' },
        { text: 'แผนก', value: 'masDepartmentName' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'หัวหน้า', value: 'empFull_NameTH_approve' },
        { text: 'ลาด่วน', value: 'leaveEmergency' }
        // {
        //   text: 'ตรวจสอบ',
        //   value: 'action',
        //   sortable: false,
        //   align: 'center'
        // }
      ],
      dataItemLeave: [],
      titleNameTH: titleNameTH,
      year: '',
      month: '',
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      panel: [0, 1],
      dialog: false,
      dataByEmp: [],
      dataItemShift: [],
      dataByEmpView: [],
      empCode: '',
      endDate: '',
      BranchItem: [], // สาขา
      DepartmentItem: [], // แผนก
      CompanyItem: [], // บริษัท
      Company: '', // บริษัท
      Branch: '', // บริษัท
      Department: '', // บริษัท
      disableBranch: true,
      disableDeparment: true,
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ]
      // End Export Config
    }
  },
  async mounted () {
    // localStorage.removeItem('dataByHR')
    await this.getGetToken()
    this.dataReady = false
    this.month = this.getMonthTh()
    let date = new Date()
    this.year = moment().format('YYYY')
    this.day = date.getDate()
    await this.getDataCompany()
    await this.getDataBranch()
    await this.getDataDepartment()

    // Get Data
    await this.getData()
    // await this.getDataInformation()

    // await this.getDataEmp()
    // this.getDataReport()
    // this.getDataTitleTH()
  },
  methods: {
    async clear () {
      console.log('clear')
      this.Company = ''
      this.Branch = ''
      this.Department = ''
      await this.getData()
    },
    async getSearch () {
      this.getDataToday()
      this.getReportCheckIN()
      this.getDataShift()
      this.getDataLeave()
    },
    async getDataReport () {
      console.log('dataByEmp', this.dataByEmp)
      console.log('เดือน', this.getMonthThToINT(this.month))
      console.log('year', this.year)
      // this.getDataToday()
      // this.getReportCheckIN()
      // this.getDataShift()
      // this.getDataLeave()
    },
    async getData () {
      this.dataReady = false
      // Clear Data ทุกครั้ง
      this.dataItem = []
      // Clear ข้อมูลใน Import

      var Company = this.Company === '' ? '' : '&masCompanyName=' + this.Company
      var Branch = this.Branch === '' ? '' : '&masBranchName=' + this.Branch
      var Department = this.Department === '' ? '' : '&masDepartmentName=' + this.Department
      var endDate = this.endDate === '' ? '' : '?endDate=' + this.endDate

      console.log('monthSearch', endDate)
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/employee_resign/get' + endDate + Company + Branch + Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          this.dataReady = true
          this.dataItem = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.dataReady = true
        })
    },
    async getDataInformation (dt) {
      this.empCode = dt.empCode
      this.empFull_NameTH = dt.empFull_NameTH
      this.masDepartmentName = dt.masDepartmentName
      this.masBranchName = dt.masBranchName
    },
    async getByEmp (dt) {
      console.log('dttttttt', dt)
      // dt.empImageUrl = this.DNS_IP + '/' + dt.empImage/Url
      this.dataReady = false
      this.dataByEmp = []
      // this.dataByEmpView = []
      // this.dataItem = []

      this.month = (this.month) ? this.month : null
      var monthSearch = (this.month !== null) ? '&shiftMonth=' + this.getMonthThToINT(this.month) : ''

      console.log('monthSearch', monthSearch)
      console.log('year', this.year)
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import_resign/get?empCode=' +
            dt.empCode +
            monthSearch +
            '&shiftYear=' +
            this.year
        )
        .then(async response => {
          this.dataReady = true
          dt.shifttem = response.data
          dt.shifttem.forEach((shifttem) => {
            if (shifttem.checkInStartStamp) {
              shifttem.colorout = 'green'

              if (!shifttem.checkInEndStamp) {
                shifttem.checkInEndStamp = 'ไม่พบข้อมูล'
                shifttem.colorout = '-'
              }

              if (shifttem.lateStatus === 'ปกติ') {
                shifttem.detail = 'ปกติ'
                shifttem.colorin = 'green'
              }

              if (shifttem.lateStatus === 'สาย') {
                shifttem.colorin = 'red'
                shifttem.detail = 'สาย'
              }

              if (shifttem.shiftCode === 'H') {
                shifttem.detail = 'วันหยุด'
              }
              if (shifttem.leave !== null) {
                shifttem.checkInStartStamp = (shifttem.leaveSummaryDayName === 'ครึ่งวันเช้า' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? shifttem.leave : shifttem.checkInStartStamp
                shifttem.checkInEndStamp = (shifttem.leaveSummaryDayName === 'ครึ่งวันบ่าย' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? shifttem.leave : shifttem.checkInEndStamp
                shifttem.colorin = (shifttem.leaveSummaryDayName === 'ครึ่งวันเช้า' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? 'blue' : shifttem.colorin
                shifttem.colorout = (shifttem.leaveSummaryDayName === 'ครึ่งวันบ่าย' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? 'blue' : shifttem.colorout
              }
            } else {
              if (shifttem.shiftCode === 'H') {
                shifttem.checkInStartStamp = 'วันหยุด'
                shifttem.checkInEndStamp = 'วันหยุด'
                shifttem.detail = 'วันหยุด'
                shifttem.colorin = 'black'
                shifttem.colorout = 'black'
              } else {
                if (shifttem.leave !== null) {
                  shifttem.checkInStartStamp = (shifttem.leaveSummaryDayName === 'ครึ่งวันเช้า' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? shifttem.leave : 'ไม่พบข้อมูล'
                  shifttem.checkInEndStamp = (shifttem.leaveSummaryDayName === 'ครึ่งวันบ่าย' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? shifttem.leave : 'ไม่พบข้อมูล'
                  shifttem.colorin = (shifttem.leaveSummaryDayName === 'ครึ่งวันเช้า' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? 'blue' : '-'
                  shifttem.colorout = (shifttem.leaveSummaryDayName === 'ครึ่งวันบ่าย' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? 'blue' : '-'
                } else {
                  shifttem.checkInStartStamp = 'ไม่พบข้อมูล'
                  shifttem.checkInEndStamp = 'ไม่พบข้อมูล'
                  shifttem.detail = 'ไม่พบข้อมูล'
                  shifttem.colorin = '-'
                  shifttem.colorout = '-'
                }
              }
            }
          })
          dt.shifttem = dt.shifttem
            .slice()
            .sort((a, b) => a.shiftDay - b.shiftDay)
          // this.getData()
          this.dataByEmp = dt
          // this.dataByEmpView = dt
          // this.dataItem = dt
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          this.dataReady = true
        })
    },
    async getDataShift () {
      console.log('getDataShift', this.empCode)
      this.dataItemShift = []

      this.month = (this.month) ? this.month : null
      var monthSearch = (this.month !== null) ? '&shiftTransferOldMonth=' + this.getMonthThToINT(this.month) : ''
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/shift_transfer/getResign?empCode=' + this.empCode +
           monthSearch +
            '&shiftTransferOldYear=' +
            this.year,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          this.dataReady = true
          this.dataItemShift = response.data
          console.log('this.dataItemShift', this.dataItemShift)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          // console.log(error)
          this.dataReady = true
        })
    },
    async getDataLeave () {
      console.log('getDataLeave', this.empCode)
      this.dataItemLeave = []

      this.month = (this.month) ? this.month : null
      var monthSearch = (this.month !== null) ? '&leaveStartMonth=' + this.getMonthThToINT(this.month) : ''
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/leave_data/getResign?empCode=' + this.empCode +
           monthSearch +
            '&leaveStartYear=' +
            this.year,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          this.dataReady = true
          this.dataItemLeave = response.data
          console.log('this.dataItemLeave', this.dataItemLeave)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.dataReady = true
        })
    },
    async clearData () {
      // eslint-disable-next-line no-redeclare
      for (var key in this.formAdd) {
        if (this.formAdd[key]) {
          this.formAdd[key] = ''
        }
      }
    },
    async resign (item) {
      console.log(item)
    },
    async getDataToday () {
      console.log('Report Check IN', this.empCode)
      this.dataByEmp = []

      this.month = (this.month) ? this.month : null
      var monthSearch = (this.month !== null) ? '&shiftMonth=' + this.getMonthThToINT(this.month) : ''

      console.log('monthSearch', monthSearch)
      console.log('year', this.year)
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import_resign/get?empCode=' +
           this.empCode +
            monthSearch +
            '&shiftYear=' +
            this.year,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          this.dataByEmp = response.data
          this.dataByEmp.forEach(shifttem => {
            if (shifttem.checkInStartStamp) {
              shifttem.colorout = 'green'

              if (!shifttem.checkInEndStamp) {
                shifttem.checkInEndStamp = 'ไม่พบข้อมูล'
                shifttem.colorout = '-'
              }

              if (shifttem.lateStatus === 'ปกติ') {
                shifttem.detail = 'ปกติ'
                shifttem.colorin = 'green'
              }

              if (shifttem.lateStatus === 'สาย') {
                shifttem.colorin = 'red'
                shifttem.detail = 'สาย'
              }

              if (shifttem.shiftCode === 'H') {
                shifttem.detail = 'วันหยุด'
              }
              if (shifttem.leave !== null) {
                shifttem.checkInStartStamp = shifttem.leave + '(' + shifttem.leaveSummaryDayName + ')'
                shifttem.checkInEndStamp = shifttem.leave + '(' + shifttem.leaveSummaryDayName + ')'
                shifttem.colorin = 'blue'
                shifttem.colorout = 'blue'
              }
            } else {
              if (shifttem.shiftCode === 'H') {
                shifttem.checkInStartStamp = 'วันหยุด'
                shifttem.checkInEndStamp = 'วันหยุด'
                shifttem.detail = 'วันหยุด'
                shifttem.colorin = 'black'
                shifttem.colorout = 'black'
              } else {
                if (shifttem.leave !== null) {
                  shifttem.checkInStartStamp = shifttem.leave + '(' + shifttem.leaveSummaryDayName + ')'
                  shifttem.checkInEndStamp = shifttem.leave + '(' + shifttem.leaveSummaryDayName + ')'
                  shifttem.colorin = 'blue'
                  shifttem.colorout = 'blue'
                } else {
                  shifttem.checkInStartStamp = 'ไม่พบข้อมูล'
                  shifttem.checkInEndStamp = 'ไม่พบข้อมูล'
                  shifttem.detail = 'ไม่พบข้อมูล'
                  shifttem.colorin = '-'
                  shifttem.colorout = '-'
                }
              }
            }
          })
          this.dataByEmp = this.dataByEmp
            .slice()
            .sort((a, b) => a.shiftDay - b.shiftDay)
          // this.getData()
          console.log('dataByEmp', this.dataByEmp)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
        })
    },
    async getReportCheckIN () {
      // console.log('Report Check IN', this.profile.masBranchName)
      // console.log('Report Check IN', this.profile.masDepartmentName)
      console.log('Report Check IN', this.empCode)
      this.dataReportMonth = []

      this.month = (this.month) ? this.month : null
      var monthSearch = (this.month !== null) ? '&shiftMonth=' + this.getMonthThToINT(this.month) : ''

      console.log('monthSearch', monthSearch)
      console.log('year', this.year)

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import_resign/reportMonthEmpCode?empCode=' +
           this.empCode +
            monthSearch +
            '&shiftYear=' +
            this.year,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async response => {
          // console.log('getReportCheckIN', response.data)
          this.dataReportMonth = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          this.dataReportMonth = []
          console.log(error)
        })
    },
    async exportByEmp () {
      // console.log('Export Emp', this.dataByEmpView.shifttem)
      console.log('Export dataByEmp', this.dataByEmp)
      var tem = []
      // var wb = XLSX.utils.book_new() // make Workbook of Excel
      this.dataByEmp.forEach(element => {
        let s = {
          'รหัสพนักงาน': element.empCode,
          'ชื่อพนักงาน': element.empFull_NameTH,
          'แผนก': element.masDepartmentName,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'ปี': element.shiftYear,
          'เดือน': element.shiftMonth,
          'วัน': element.shiftDay,
          'วันเดือนปี': element.shiftDay + '/' + element.shiftMonth + '/' + element.shiftYear,
          'รหัสกะ': element.masShiftTypeCode,
          'กะเข้างาน': element.masShiftTypeStartTime,
          'กะเวลาออกงาน': element.masShiftTypeEndTime,
          'สถานที่ทำงาน': element.location,
          'เวลาเข้างาน': element.checkInStartStamp,
          'เวลาออกงาน': element.checkInEndStamp,
          'สถานะสาย': element.lateStatus,
          'สาย(นาที)': element.lateTime,
          'ระดับสีประเมินความเสี่ยง': element.color
        }
        tem.push(s)
      })
      console.log('tem', tem)
      var info = XLSX.utils.json_to_sheet(tem)
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, info, 'worksheet') // sheetAName is name of Worksheet

      var tempShift = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/shift_transfer/getResign?empCode=" + this.dataByEmp.empCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          response.data.forEach(element => {
            let s = {
              'รหัสพนักงาน': element.empCode,
              'ประเภท': element.shiftTransferType,
              'พนักงาน': element.empFull_NameTH,
              'กะปัจุบัน': element.shiftTransferOldShiftCodeName,
              'เพื่อน': element.empFull_NameTH_Friend,
              'กะที่สลับ': element.shiftTransferNewShiftCodeName,
              'หมายเหตุ': element.shiftTransferRemark,
              'เพื่อนอนุมัติ': element.shiftTransferFriendAppoveStatus,
              'หัวหน้าอนุมัติ': element.shiftTransferAppoveStatus,
              'ทำรายการล่าสุด': element.lastUser
            }
            tempShift.push(s)
          })
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })

      var Shift = XLSX.utils.json_to_sheet(tempShift)
      XLSX.utils.book_append_sheet(wb, Shift, 'รายการขอสลับกะ')

      var tempLeave = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/leave_data/getResign?empCode=" + this.dataByEmp.empCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          response.data.forEach(element => {
            let s = {
              'รหัสพนักงาน': element.empCode,
              'พนักงาน': element.empFull_NameTH,
              'ประเภท': element.quotaLeaveName,
              'ตั้งแต่': element.leaveStartDate,
              'ถึง': element.leaveEndDate,
              'จำนวน': element.leaveSummaryDay,
              'แผนก': element.masDepartmentName,
              'สาขา': element.masBranchName,
              'หัวหน้า': element.empFull_NameTH_approve,
              'ลาด่วน': element.leaveEmergency
            }
            tempLeave.push(s)
          })
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })

      var Leave = XLSX.utils.json_to_sheet(tempLeave)
      XLSX.utils.book_append_sheet(wb, Leave, 'รายการขอลา')

      XLSX.writeFile(
        wb,
        'ช้อมูลพนักงาน(' +
          this.empFull_NameTH +
          '' +
          ' ' +
         this.month +
          ' ' +
          this.year +
          ').xls'
      ) // name of the file is 'book.xlsx'
    },
    exportData () {
      this.dataItem = []
      axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/employee_resign/get',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          this.dataItem = response.data
          var tem = []
          response.data.forEach(element => {
            let s = {
              รหัสพนักงาน: element.empCode,
              คำนำหน้าชื่อไทย: element.empTitle_NameTH,
              ขื่อไทย: element.empFirst_NameTH,
              นามสกุลไทย: element.empLast_NameTH,
              'ขื่อ-นามสกุลไทย': element.empFull_NameTH,
              คำนำหน้าชื่ออังกฤษ: element.empTitle_NameEN,
              ชื่อภาษาอังกฤษ: element.empFirst_NameEN,
              นามสกุลอังกฤษ: element.empLast_NameEN,
              'ชื่อ-นามสกุลอังกฤษ': element.empFull_NameEN,
              ชื่อเล่น: element.empNickname,
              วันเกิด: element.empBirthday,
              อายุ: element.AGE,
              เพศ: element.empGender,
              เบอร์ติดต่อ: element.empTel,
              รหัสบัตรประชาชน: element.empIDCard,
              Facebook: element.empFacebook,
              'LINE ID': element.empLineID,
              เบอร์ฉุกเฉิน: element.empEmergencyCall,
              เลขใบขับขี่: element.empDriverLicense,
              ประเภทใบขับขี่: element.empDriverLicenseType,
              งานอดิเรก: element.hobby,
              ความสามารถพิเศษอื่นๆ: element.empGenius,
              วันทำบัตรประชาชน: element.issuedDate,
              วันหมดอายุบัตรประชาชน: element.expireDate,
              สถานที่ทำบัตรประชาชน: element.issuedAt,
              จังหวัดที่ทำบัตรประชาชน: element.issuedProvince,
              รับรองทางทหาร: element.masMilitaryStatusCode,
              รหัสตำแหน่ง: element.positionCode,
              ตำแหน่งงาน: element.positionName,
              ประเภทตำแหน่งงาน: element.positionTypeName,
              แผนก: element.masDepartmentName,
              สาขา: element.masBranchName,
              บริษัท: element.masCompanyName,
              วันที่เริ่มทำงาน: element.startDate,
              วันที่ลาออก: element.endDate,
              เหตุผลที่ลาออก: element.empResignRemark
            }
            tem.push(s)
          })
          console.log(tem)
          var info = XLSX.utils.json_to_sheet(tem)
          var wb = XLSX.utils.book_new() // make Workbook of Excel
          XLSX.utils.book_append_sheet(wb, info, 'worksheet') // sheetAName is name of Worksheet
          var month = this.getMonthTh()
          let date = new Date()
          var year = moment().format('YYYY')
          var day = date.getDate()

          XLSX.writeFile(
            wb,
            'ช้อมูลพนักงานที่ลาออก(' + day + ' ' + month + ' ' + year + ').xls'
          ) // name of the file is 'book.xlsx'
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
        })
    },
    // บริษัท
    async getDataCompany () {
      this.CompanyItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/master_company/getItem',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          console.log('Company', response.data)
          this.dataReady = true
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masCompanyName
            s.value = d.masCompanyName
            d = s
            this.CompanyItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
        })
    },
    // สาขา
    async getDataBranch () {
      this.BranchItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/master_branch/getItem',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          console.log('Company', response.data)
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masBranchName
            s.value = d.masBranchName
            d = s
            this.BranchItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
        })
    },
    // แผนก
    async getDataDepartment () {
      this.DepartmentItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/master_department/getItem',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          console.log('getDataDepartment : ', this.DepartmentItem)
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masDepartmentName
            s.value = d.masDepartmentName
            d = s
            this.DepartmentItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
        })
    },
    departmentCheckSearch (departmentCheckSearch) {
      if (departmentCheckSearch) {
        this.disableSearch = true
      }
    }
  }
}
</script>
<style>
.v-data-table-header {
  background-color: #1b437c !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Employee/EmployeeResign.vue